module.exports = __webpack_public_path__ + "static/media/03.797978c1.jpg";